export default __webpack_public_path__ + "static/media/penny.797c7283.png";